export enum NotificationStatusEnum {
  info,
  warning,
  critical,
}
